// faqData.js
export const faqData = [
  {
    question: "What is FNFT?",
    answer: "FNFT stands for Fractional NFT, which allows ownership of a digital asset to be divided into smaller fractions, enabling multiple investors to hold a portion of it."
  },
  {
    question: "How does FNFT differ from traditional NFTs?",
    answer: "Unlike traditional NFTs, which represent full ownership of a digital asset, FNFTs allow fractional ownership, making them more accessible to a broader audience."
  },
  {
    question: "What is a Launchpad?",
    answer: "A Launchpad is a platform that helps new blockchain projects raise funds and launch their tokens in a decentralized manner."
  },
  {
    question: "How do I participate in a Launchpad?",
    answer: "You can participate by following the platform's token sale process, usually requiring a wallet connection and sometimes a KYC process."
  },
  {
    question: "What is F-NFT and how does it work?",
    answer: "F-NFT refers to fractional NFTs, where ownership of an NFT is split into multiple parts, allowing multiple investors to own fractions of the same NFT."
  },
  {
    question: "What are the benefits of F-NFTs?",
    answer: "F-NFTs allow for increased liquidity, accessibility for smaller investors, and shared ownership of high-value digital assets."
  },
  {
    question: "What is the Launchpad fundraising process?",
    answer: "The fundraising process involves launching a new token or project through the platform, where investors can purchase tokens to support the project."
  },
  {
    question: "How can I mint a new FNFT?",
    answer: "You can mint a new FNFT by using platforms that support fractionalized NFTs, following their guidelines to divide your digital asset into fractions."
  },
  {
    question: "What is the difference between Launchpad and traditional fundraising?",
    answer: "Traditional fundraising often involves centralized entities, while Launchpads provide a decentralized way for projects to raise funds through token sales."
  },
  {
    question: "How secure is FNFT investment?",
    answer: "FNFT investments rely on blockchain security, but like any investment, there are risks involved, including market volatility and project reliability."
  },
  {
    question: "What are the risks of investing in F-NFTs?",
    answer: "Risks include project failure, market volatility, and the possibility that the fractional NFT may not gain significant value over time."
  },
  {
    question: "What is the process of launching a token on a Launchpad?",
    answer: "The process involves project approval, setting up a fundraising goal, and offering tokens to investors in exchange for funds raised."
  },
  {
    question: "How does governance work in fractional NFTs?",
    answer: "Ownership of fractional NFTs usually comes with governance rights, allowing investors to vote on important decisions related to the asset."
  },
  {
    question: "Can fractional NFTs be traded?",
    answer: "Yes, fractional NFTs can be traded on various marketplaces that support the buying and selling of fractions of NFTs."
  },
  {
    question: "How do I connect my wallet to a Launchpad?",
    answer: "You can connect your wallet using platforms like MetaMask or WalletConnect, depending on the Launchpad’s supported wallets."
  },
  {
    question: "What are the benefits of using a Launchpad?",
    answer: "Launchpads provide decentralized fundraising, early access to new projects, and often give investors a chance to participate in token sales before public release."
  },
  {
    question: "How do FNFTs improve liquidity?",
    answer: "FNFTs improve liquidity by allowing fractions of high-value NFTs to be traded independently, making it easier to sell portions of the asset."
  },
  {
    question: "What is the typical cost of minting an FNFT?",
    answer: "The cost varies based on the platform and the blockchain fees, but it generally includes gas fees and platform-specific charges."
  },
  {
    question: "How do I determine the value of an FNFT?",
    answer: "The value of an FNFT is typically determined by the value of the underlying NFT and the demand for fractional ownership."
  },
  {
    question: "What are the tax implications of owning fractional NFTs?",
    answer: "Tax laws vary by jurisdiction, but generally, owning and selling FNFTs may be subject to capital gains tax, depending on your local regulations."
  },
  {
    question: "What is fundraising in the crypto world?",
    answer: "Fundraising in the crypto world involves raising funds for blockchain projects through token sales, often using Launchpads to facilitate the process."
  },
  {
    question: "Can fractional NFTs be converted back into a whole NFT?",
    answer: "Yes, in some cases, fractional NFTs can be recombined into a whole NFT, but it depends on the platform’s specific rules and the agreement among fraction holders."
  }
];
